import { FabricPlugin } from "../../FabricPlugin";
import { roundRect } from "../../../utils/utils";
import imgFunction from "../../../../../images/send_24px.svg";

/**
 * @description - CallPlugin used in SmartContractDesigner
 */
export class EmitEventPlugin extends FabricPlugin {
    fillStyle = "#4747CC";

    radius = 5;

    name = "Emit Event";

    img = new Image();

    constructor(options, ctx, data) {
        super(options, ctx, data);
        this.points = { start: 1, end: 1, initial: 4 };
    }

    /**
    * @description Draws the plugin
    */
    draw() {
        const size = super.getSize();
        const position = super.getPosition();
        const styles = { fillStyle: this.fillStyle };
        roundRect(position.x, position.y, size.width, size.height, 4, styles, this.ctx);
        if (!this.img.src) {
            this.img.onload = () => { this.ctx.drawImage(this.img, position.x + size.width / 4, position.y + size.height / 4); };
            this.img.src = imgFunction;
        }
        this.ctx.drawImage(this.img, position.x + size.width / 4, position.y + size.height / 4);
        this.fabricPluginRedrawed();
    }

    /**
     * @description Updates the plugin
     * @param options - {size,position}
     */
    update(options) {
        this.setPosition(options && options.position ? options.position : super.getPosition());
        this.setSize(options && options.size ? options.size : super.getSize());
    }
}
